import React, { Component } from 'react'
import { array, func, string, bool } from 'prop-types'
import classNames from 'classnames'
import I18n from 'lib/i18n'

export default class AmountStep extends Component {
  static propTypes = {
    options: array,
    value: string,
    onChange: func.isRequired,
    error: string,
    disabled: bool,
    errorRef: func.isRequired
  }

  constructor (props) {
    super(props)
    this.handleInput = this.handleInput.bind(this)
    this.handleOptionSelect = this.handleOptionSelect.bind(this)
  }

  handleInput ({ target: { value } }) {
    this.props.onChange({ name: 'amount', value: parseFloat(value) || null })
  }

  handleOptionSelect (option) {
    this.props.onChange({ name: 'amount', value: option })
  }

  render () {
    const { handleOptionSelect, handleInput, props } = this
    const { options, value, disabled, errorRef, error } = props
    return (
      <div className="step choose_amount">
        <h4 className="title">
          <span className="fix_title">1. Choose amount</span>
        </h4>
        <div className="select_amount_container">
          <div className="select_amount">
            {options && options.map((option) => {
              return (
                <button
                  className={classNames('button', { active: value === option.toString() })}
                  onClick={() => {
                    handleOptionSelect(option)
                  }}
                  key={option}
                >
                  {I18n.numberToCurrency(option)}
                </button>
              )
            })}
          </div>
        </div>
        <div className="amount input_wrap">
          <input
            type="number"
            name="amount"
            className="input_field"
            placeholder="Amount"
            onChange={handleInput}
            value={value || ''}
            disabled={disabled}
          />
          <label htmlFor="amount" className="input_label">
            Amount
          </label>
        </div>
        {error && (
          <div
            className="error"
            ref={errorRef}
          >
            {error}
          </div>
        )}
      </div>
    )
  }
}
